import { getSolutionName, getSolutionId } from "template-store/services/solution-data-service";
import Categories from "template-store/constants/categories";
const CATEGORIES_TO_REMOVE = [
    Categories.FEATURED_TEMPLATES
];
export const solutionExists = (allSolutions, solutionId)=>{
    return !!getSolutionData(allSolutions, solutionId);
};
export const getSolution = (allSolutions, solutionId)=>{
    const solution = allSolutions.find((sol)=>getSolutionId(sol).toString() === solutionId);
    return solution;
};
export const getSolutionData = (allSolutions, solutionId)=>{
    const solution = getSolution(allSolutions, solutionId);
    return solution === null || solution === void 0 ? void 0 : solution.data;
};
export const categoryExists = (allCategories, categoryId)=>{
    return !!allCategories.find((category)=>(category === null || category === void 0 ? void 0 : category.value) === categoryId);
};
export const filterCategories = (allCategories, allSolutions)=>{
    // filter out categories which have only templates and unwanted categories
    return allCategories.filter((category)=>doesCategoryContainSolutions(allSolutions, category === null || category === void 0 ? void 0 : category.value) && !CATEGORIES_TO_REMOVE.includes(category === null || category === void 0 ? void 0 : category.value));
};
export const getSolutionsInCategory = (allSolutions, categoryId)=>{
    const solutionsInCategory = allSolutions.filter((solution)=>{
        var _solution_data_categories;
        return (_solution_data_categories = solution.data.categories) === null || _solution_data_categories === void 0 ? void 0 : _solution_data_categories.includes(categoryId);
    });
    const topTemplates = solutionsInCategory.filter((solution)=>solution.data.isTopTemplate); //sort runs in different order in browser and node resulting in server client inconsistancy
    const nonTopTemplates = solutionsInCategory.filter((solution)=>!solution.data.isTopTemplate);
    return topTemplates.concat(nonTopTemplates);
};
export const doesCategoryContainSolutions = (allSolutions, categoryId)=>{
    return !!allSolutions.find((solution)=>{
        var _solution_data_categories;
        return (_solution_data_categories = solution.data.categories) === null || _solution_data_categories === void 0 ? void 0 : _solution_data_categories.includes(categoryId);
    });
};
const doesSolutionMatchSearchTerm = (solutionData, searchTerm)=>{
    const solutionName = getSolutionName(solutionData); // Will add more search options in the near future
    if (!solutionName || !searchTerm) return false;
    return solutionName.toLowerCase().includes(searchTerm.toLowerCase());
};
export const filterSolutions = (allSolutions, searchTerm)=>{
    return allSolutions.filter((solution)=>doesSolutionMatchSearchTerm(solution.data, searchTerm));
};
export const getMostPopularSolutions = (allSolutions)=>{
    return allSolutions.filter((solution)=>solution.data.isMostPopular);
};
export const getNewAndNotableSolutions = (allSolutions)=>{
    return allSolutions.filter((solution)=>solution.data.isNewAndNotable);
};
